import { formatOrDefault } from "../../util/date/formatOrDefault";
import { tryParseUtcToLocalDate } from "../../util/date/TimeZone";
import { isNullOrWhiteSpace } from "../../util/functions/isNullOrWhiteSpace";
import { computed, makeObservable } from "mobx";

export class NewsItem {
	constructor(
		public readonly id: number,
		public readonly header: string,
		public readonly body: string,
		private readonly from: string, //UTC
		private readonly until: string, //UTC
		public readonly popup: boolean,
		public readonly maintenance: boolean,
		private readonly created: string,
		private readonly updated: string,
		public readonly visible: boolean,
		public readonly language: string,
		public readonly hoursUpFront: number,
	) {
		makeObservable(this);
	}

	@computed
	public get fromLocalDateTime(): string | null {
		if (isNullOrWhiteSpace(this.from)) return null;

		const localDate = tryParseUtcToLocalDate(this.from);
		if (!localDate) return this.from;

		return formatOrDefault(localDate, "dd/MM/yyyy HH:mm", this.from);
	}

	@computed
	public get untilLocalDateTime(): string | null {
		if (isNullOrWhiteSpace(this.until)) return null;

		const localDate = tryParseUtcToLocalDate(this.until);
		if (!localDate) return this.until;

		return formatOrDefault(localDate, "dd/MM/yyyy HH:mm", this.until);
	}

	@computed
	public get uid(): string {
		return this.id + "__" + this.updated;
	}
}

export interface IPow3NewsItem {
	readonly id: number;
	readonly created: string;
	readonly updated: string;
	readonly visible: boolean;
	readonly header: string;
	readonly body: string;
	readonly language: string;
	readonly from: string; //UTC
	readonly until: string; //UTC
	readonly popup: boolean;
	readonly maintenance: boolean;
	readonly hoursUpFront: number;
}
